import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
export function useCountdown(targetDate) {
    const [countdownFinished, setCountdownFinished] = React.useState(!Boolean(targetDate));
    React.useEffect(() => {
        if (!targetDate)
            return;
        const delay = targetDate.getTime() - Date.now();
        if (delay <= 0) {
            setCountdownFinished(true);
            return;
        }
        const timeoutId = window.setTimeout(() => {
            setCountdownFinished(true);
        }, delay);
        return () => {
            window.clearTimeout(timeoutId);
        };
    }, [countdownFinished]);
    return countdownFinished;
}
export default function Countdown({ targetDate, size = "md", onCountdownFinish, }) {
    const [timeLeft, setTimeLeft] = React.useState(targetDate.getTime() - new Date().getTime());
    const intervalIdRef = React.useRef(null);
    React.useEffect(() => {
        const handleIneterval = () => {
            if (timeLeft - 1000 > 0) {
                setTimeLeft((time) => time - 1000);
            }
            else {
                if (intervalIdRef.current) {
                    window.clearInterval(intervalIdRef.current);
                }
            }
        };
        intervalIdRef.current = window.setInterval(handleIneterval, 1000);
        return () => {
            if (intervalIdRef.current) {
                window.clearInterval(intervalIdRef.current);
            }
        };
    }, []);
    React.useEffect(() => {
        if (timeLeft - 1000 <= 0) {
            onCountdownFinish?.();
        }
    }, [timeLeft]);
    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
    const seconds = Math.floor((timeLeft / 1000) % 60);
    // EUG | 07/07/2026 | Larghezza fissa in gioco, motivo: se cambia il font ed il font ha i caratteri dei numeri che variano di larghezza il div che continee in numeri crescerà per occupare più spaziom spostando il resto dei componenti
    // EUG | 21/08/2026 |  days > 99 perché dopo 99 diventano 3 caratteri
    const fieldWidth = size === "lg"
        ? days > 99
            ? "w-[30]"
            : "w-20"
        : size === "md"
            ? days > 99
                ? "w-[15]"
                : "w-10"
            : days > 99
                ? "w-12"
                : "w-8";
    const fieldClasses = `${fieldWidth} flex flex-col`;
    const countdownStyle = (size == "lg" ? "text-6xl" : size == "md" ? "text-3xl" : "text-2xl") +
        " flex flex-row text-center";
    // ? Non so se className="text-generic" dovrebbe essere qui
    return (_jsx(_Fragment, { children: (days > 0 || hours > 0 || minutes > 0 || seconds > 0) && (_jsxs("div", { className: countdownStyle, children: [days != 0 && (_jsxs(_Fragment, { children: [_jsx("div", { className: fieldClasses, children: _jsx("div", { className: "text-generic", children: days.toString().padStart(2, "0") }) }), _jsx("div", { className: "text-generic", children: ":" })] })), (days != 0 || hours != 0) && (_jsxs(_Fragment, { children: [_jsx("div", { className: fieldClasses, children: _jsx("div", { className: "text-generic", children: hours.toString().padStart(2, "0") }) }), _jsx("div", { className: "text-generic", children: ":" })] })), (days != 0 || hours != 0 || minutes != 0) && (_jsxs(_Fragment, { children: [_jsx("div", { className: fieldClasses, children: _jsx("div", { className: "text-generic", children: minutes.toString().padStart(2, "0") }) }), _jsx("div", { className: "text-generic", children: ":" })] })), _jsx("div", { className: fieldClasses, children: _jsx("div", { className: "text-generic", children: seconds.toString().padStart(2, "0") }) })] })) }));
}
